import { ref, reactive } from "vue";
import axios from "axios";
import { useRoute } from "vue-router";
import { useToast } from "vue-toastification";

export default function useHome() {
  const home = reactive({});
  const application = reactive({});
  const cooperationSale = reactive({});
  const popup = ref(null);
  const bug = reactive({});
  const payment = reactive({});
  const recruitment = reactive({});
  const formData = reactive({});
  const progressDialog = window.progressDialog;
  const loading = ref(true);
  const errors = ref(null);
  const toast = useToast();
  const route = useRoute();

  const getPopup = async () => {
    let data = {};
    let pop = {};
    try {
      let response = await axios.get("popup");
      data = response.data.data;
      if (localStorage.getItem("observed_popup") !== data.name) pop = data;
    } catch (e) {}
    if (!pop.name && route.name == 'product.special' && window.nikran.special_sale)
      pop = { type: "notice", description: window.nikran.special_sale };
    if (pop.type)
      setTimeout(() => (popup.value = pop), data.delay_time ?? 2000);
  };

  const getApplication = async () => {
    try {
      if (application.description) {
        application.show = true;
        return false;
      }
      errors.value = "";
      loading.value = true;
      let response = await axios.get("application");
      loading.value = false;
      const data = response.data;
      Object.assign(application, { ...data, show: true });
    } catch (e) {
      loading.value = false;
      errors.value = e;
    }
  };

  const getCooperationSale = async () => {
    try {
      errors.value = "";
      loading.value = true;
      let response = await axios.get("cooperation-sale");
      loading.value = false;
      const data = response.data;
      Object.assign(cooperationSale, data);
    } catch (e) {
      loading.value = false;
      errors.value = e;
    }
  };

  const registerCooperationSale = async (page) => {
    try {
      loading.value = true;
      const res = await axios.post("user/sale", { page });
      loading.value = false;
      const data = res.data.data;
      toast.success(res.data.message);
      const token = data.token;
      delete data.token;
      cooperationSale.registered = true;
      localStorage.setItem("sale-token", token);
      localStorage.removeItem("sale-user", data);
    } catch (e) {
      window.networkError(e);
      loading.value = false;
    }
  };

  const getBugReport = async () => {
    try {
      errors.value = "";
      loading.value = true;
      let response = await axios.get("bug-report");
      loading.value = false;
      const data = response.data;
      bug.fields = data.fields;
      bug.contact = data.contact;
      if (bug.fields.find((item) => item.name == "your-name"))
        formData["your-name"] = data.username;
    } catch (e) {
      loading.value = false;
      errors.value = e;
    }
  };

  const sendForm = async (type) => {
    try {
      progressDialog.value = true;
      formData.type = type;
      let response = await axios({
        baseURL: window.APP_URL + "/api",
        method: "post",
        url: "send-form",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (type == "bug") bug.success_message = response.data.message;
      else recruitment.success_message = response.data.message;
      progressDialog.value = false;
    } catch (e) {
      progressDialog.value = false;
      window.networkError(e);
    }
  };

  const getRecruitmentForm = async () => {
    try {
      errors.value = "";
      loading.value = true;
      let response = await axios.get("recruitment-form");
      loading.value = false;
      const data = response.data;
      recruitment.fields = data.fields;
      recruitment.contact = data.contact;
      if (recruitment.fields.find((item) => item.name == "your-name"))
        formData["your-name"] = data.username;
    } catch (e) {
      loading.value = false;
      errors.value = e;
    }
  };

  const installApplication = () => {
    let deferredPrompt = window.deferredPrompt;
    application.show = false;
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then(function (choice) {
        if (choice.outcome === "dismissed") {
          console.log("install cancel");
        }
      });
      deferredPrompt = null;
    }
  };

  const removePopup = () => {
    localStorage.setItem("observed_popup", popup.value.name);
    popup.value = null;
  };

  const getHome = async () => {
    let response = await axios.get("home");
    Object.assign(home, response.data);
  };

  const getPayment = async () => {
    try {
      errors.value = "";
      loading.value = true;
      const res = await axios.get("payment/" + route.params.track);
      Object.assign(payment, res.data.data);
      loading.value = false;
    } catch (e) {
      errors.value = e;
      loading.value = false;
    }
  };

  return {
    loading,
    getPopup,
    removePopup,
    getBugReport,
    getRecruitmentForm,
    sendForm,
    recruitment,
    bug,
    formData,
    popup,
    home,
    payment,
    application,
    cooperationSale,
    registerCooperationSale,
    installApplication,
    getApplication,
    getPayment,
    getCooperationSale,
    getHome,
  };
}
